<template>
    <div>
        <img v-show="!loading" ref="img" :src="src" :class="classStr" :style="styleStr" @load="loadComplete"/>
        <slot name="loading" v-if="loading">
            <!-- 默认提供一张图片 -->
            <!-- 注意，要想让 iconfont 转动起来，必须在块元素 div 上添加 rotate 样式 -->
            <div class="rotate"><i class="iconfont icon-sy-loading" style="font-size: 50px"></i></div>
        </slot>
    </div>
</template>

<script>
    export default {
        name: "SyLoadingImage",
        props: {
            src: String,
            styleStr: String,  // 使用 str 的方式更简单，看 Avatar 是如何调用的
            classStr: String   // 这里还真没有太好的办法，class 需要传递到 img 元素上，且还会随着时间的变化而变化
        },
        data() {
            return {
                loading: true
            }
        },
        methods: {
            loadComplete: function(){
                console.log(`the img of src ${this.src} load completed`);
                this.loading = false;
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/commons/SyLoadingImage.vue